var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_RosterTemplate_list_title"),
      addBtn: _vm.hasBtn("add-admin-roster-template"),
      pad: "0",
      filterable: "",
    },
    on: {
      new: _vm.toNew,
      activated: _vm.activated,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
                "filter-page-data": _vm.filterPageData,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "text--primary table-title",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.roster_weekly_template_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.roster_weekly_template_name
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(_vm._s(item.roster_type)),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn("delete-admin-roster-template"),
                          viewBtn: _vm.hasBtn("view-admin-roster-template"),
                          editBtn: _vm.hasBtn("edit-admin-roster-template"),
                          title: _vm.$t(
                            "label_essweb_RosterTemplate_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }